import { render } from "./UsersButton.vue?vue&type=template&id=728df7b7&scoped=true&ts=true&lang=pug"
import script from "./UsersButton.vue?vue&type=script&lang=ts"
export * from "./UsersButton.vue?vue&type=script&lang=ts"

import "./UsersButton.vue?vue&type=style&index=0&id=728df7b7&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-728df7b7"]])

export default __exports__